import us from './us.json'

export default {
  "us": us
}